"use client";

import { useUserRealmId } from "@easybiz/component-shared";
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

export default (dateTag, businessCode) => {
  const realmId = useUserRealmId();
  const [receipt, setReceipt] = useState(null);

  useEffect(() => {
    setReceipt(null);
    if (realmId && dateTag && businessCode) {
      return onSnapshot(doc(getFirestore(), `realms/${realmId}/receipts/${dateTag}-${businessCode}`), setReceipt);
    }
  }, [realmId, dateTag, businessCode]);

  return receipt;
};
